import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaArrowRight, FaBullhorn } from 'react-icons/fa';

function TopHeader() {
    const marqueeRef = useRef(null);

    return (
        <>
            <nav className="top-header-exact">
                <div className="container-fluid px-4 d-flex flex-wrap justify-content-between align-items-center">
                    
                    {/* Empty left space for balance */}
                    <div className="d-none d-lg-block" style={{ width: '150px' }}></div>

                    {/* Center Marquee */}
                    <div className="marquee-wrapper flex-grow-1 mx-3" style={{ overflow: "hidden", maxWidth: "800px" }}>
                        <marquee
                            behavior="scroll"
                            scrollamount="5"
                            className="marquee-text"
                            onMouseEnter={() => marqueeRef.current?.stop()}
                            onMouseLeave={() => marqueeRef.current?.start()}
                            ref={marqueeRef}
                        >
                            <div className="d-flex align-items-center justify-content-center w-100">
                                <FaBullhorn className="me-2" style={{ color: '#38bdf8', fontSize: '16px' }} />
                                <span>Still You can file Your ITR | Start Your Tax Saving Today:-</span>
                                <Link to="/contact" className="ms-3 text-decoration-none">
                                    <button className="top-header-btn">
                                        Click Here <FaArrowRight className="ms-1" style={{ fontSize: '11px' }} />
                                    </button>
                                </Link>
                            </div>
                        </marquee>
                    </div>

                    {/* Social Icons Right */}
                    <div className="social-icons-exact">
                        <a href="https://www.facebook.com/compliancekare/" target="_blank" rel="noreferrer" className="s-icon">
                            <FaFacebookF />
                        </a>
                        <a href="https://www.instagram.com/compliancekare/" target="_blank" rel="noreferrer" className="s-icon">
                            <FaInstagram />
                        </a>
                        <a href="https://twitter.com/compliancekare/" target="_blank" rel="noreferrer" className="s-icon">
                            <FaTwitter />
                        </a>
                        <a href="#" target="_blank" rel="noreferrer" className="s-icon">
                            <FaYoutube style={{ color: '#ff0000' }} />
                        </a>
                    </div>
                </div>
            </nav>

            <style dangerouslySetInnerHTML={{
                __html: `
                .top-header-exact {
                    background: #0b224d; /* Dark navy blue from image */
                    padding: 8px 0;
                    color: #fff;
                    position: relative;
                    z-index: 1040;
                    transform: translateZ(0); /* Fix stacking context overlap on zoom */
                    border-bottom: 1px solid rgba(255,255,255,0.1);
                }

                .marquee-text {
                    color: #e2e8f0;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    margin: 0;
                    display: flex;
                    align-items: center;
                }

                .top-header-btn {
                    background: linear-gradient(90deg, #0ea5e9, #2563eb);
                    color: #fff;
                    border: none;
                    border-radius: 20px;
                    padding: 5px 18px;
                    font-weight: 700;
                    font-size: 13px;
                    display: inline-flex;
                    align-items: center;
                    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
                    transition: all 0.3s ease;
                }
                .top-header-btn:hover {
                    background: linear-gradient(90deg, #38bdf8, #3b82f6);
                    transform: translateY(-1px);
                    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.6);
                }

                .social-icons-exact {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                .s-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    background: #000; /* Solid black circles */
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-decoration: none;
                    font-size: 13px;
                    transition: all 0.3s ease;
                }
                .s-icon:hover {
                    transform: translateY(-2px);
                    background: #222;
                    color: #fff;
                }
            `}} />
        </>
    );
}

export default TopHeader;
